import React, { memo, useMemo } from "react";
import { Link } from "react-router-dom";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar, Doughnut } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Tooltip,
  Legend,
);

function AdminUploadCard({
  title = "업로드 현황",
  total = 0,
  trendLabel = "",
  uploadStats7d = {},
  moreTo,
}) {
  const bars = Array.isArray(uploadStats7d?.bars) ? uploadStats7d.bars : [];
  const typeCount = uploadStats7d?.typeCount ?? { image: 0, video: 0 };

  const totalCount = Number(uploadStats7d?.total ?? total ?? 0);
  const imageCount = Number(typeCount?.image ?? 0);
  const videoCount = Number(typeCount?.video ?? 0);

  const COLORS = {
    bar: "rgba(59, 130, 246, 0.75)",
    barBorder: "rgba(37, 99, 235, 1)",
    barHover: "rgba(96, 165, 250, 0.85)",
    image: "rgba(59, 130, 246, 0.85)",
    video: "rgba(245, 158, 11, 0.85)",
    other: "rgba(156, 163, 175, 0.85)",
    grid: "rgba(0, 0, 0, 0.08)",
    text: "rgba(0, 0, 0, 0.65)",
  };

  const barData = useMemo(
    () => ({
      labels: bars.map((b) => b.day),
      datasets: [
        {
          label: "업로드",
          data: bars.map((b) => Number(b.value ?? 0)),
          borderRadius: 8,
          backgroundColor: COLORS.bar,
          borderColor: COLORS.barBorder,
          borderWidth: 1,
          hoverBackgroundColor: COLORS.barHover,
        },
      ],
    }),
    [bars],
  );

  const barOptions = useMemo(
    () => ({
      responsive: true,
      maintainAspectRatio: false,
      animation: false,
      plugins: {
        legend: { display: false },
      },
      scales: {
        x: {
          grid: { display: false },
          ticks: { color: COLORS.text },
        },
        y: {
          beginAtZero: true,
          grid: { color: COLORS.grid },
          ticks: { color: COLORS.text },
        },
      },
    }),
    [],
  );

  const typeDonutData = useMemo(
    () => ({
      labels: ["이미지", "동영상"],
      datasets: [
        {
          data: [imageCount, videoCount],
          borderWidth: 2,
          backgroundColor: [COLORS.image, COLORS.video, COLORS.other],
          borderColor: ["#fff", "#fff"],
          hoverOffset: 6,
        },
      ],
    }),
    [imageCount, videoCount],
  );

  const donutOptions = useMemo(
    () => ({
      responsive: true,
      maintainAspectRatio: false,
      animation: false,
      cutout: "70%",
      plugins: {
        legend: {
          position: "bottom",
          labels: {
            color: COLORS.text,
            boxWidth: 12,
            boxHeight: 12,
            padding: 12,
          },
        },
      },
    }),
    [],
  );

  const showEmpty = bars.length === 0 && totalCount === 0;

  return (
    <div className="card uploadCard">
      <div className="cardHeader">
        <h3>{title}</h3>
        <div className="uploadSummary">
          <span className="total">{totalCount || ""}</span>
          {trendLabel ? <span className="trend up">{trendLabel}</span> : null}
        </div>
      </div>

      <div className="chart">
        {showEmpty ? (
          <div className="empty">최근 7일 업로드 데이터가 없습니다.</div>
        ) : (
          <Bar data={barData} options={barOptions} />
        )}
      </div>

      <div className="donutGrid">
        <div className="donutBox">
          <p className="donutTitle">파일 유형</p>
          <div style={{ height: 220 }}>
            <Doughnut data={typeDonutData} options={donutOptions} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(AdminUploadCard);
